import { Amplify } from 'aws-amplify';

// AWS Cognito Configuration for Amplify v6
const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-2_y6QzkM89Q', // Your User Pool ID
      userPoolClientId: '5komk2o44f503r6pj1m283nhtr', // Replace with your new Client ID
      region: 'us-east-2', // Your AWS region
      loginWith: {
        email: true,
        username: true
      }
      // Removed storage configuration to avoid deep freeze issues
      // Amplify will use default localStorage automatically
    }
  }
};

// Configure Amplify exactly once at module import time
Amplify.configure(awsConfig);

export default awsConfig;
